module.exports = __webpack_public_path__ + "static/img/none-data.0de600b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/imgs/none-data.png
// module id = Za4K
// module chunks = 35